import React from 'react';
import { Icon } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import entityIcons from '@/constants/images';

const CellIcon = ({
  colour,
  entity,
  loading,
  message,
  name,
  title,
}) => {
  const intl = useIntl();
  return (
    <Icon
      color={colour}
      className={colour ? undefined : 'primary'}
      name={loading ? 'circle notched' : name || entityIcons[entity]}
      loading={loading}
      title={title || intl.formatMessage({ id: message || `icon.${entity}` })}
    />
  );
};

export default CellIcon;
